// Import the notification actions
import moment from "moment";
import {
    type NotificationActionTypes,
    type NotificationDeletedAction,
    type NotificationInsertAction,
    type NotificationList,
    type NotificationReadAction,
    type NotificationState,
} from "#/Actions/Notifications/NotificationActions.ts";
import {
    NOTIFICATION_ALL_DELETE,
    NOTIFICATION_ALL_READ,
    NOTIFICATION_DELETED,
    NOTIFICATION_INSERT,
    NOTIFICATION_READ,
    NOTIFICATIONS_FETCHED,
    NOTIFICATIONS_FETCHING,
} from "#/Actions/Notifications/NotificationConstants.ts";
import { type ShopfrontActions } from "#/Utilities/Generic/ActionsHelper.ts";

function deleteNotificationFromState(state: NotificationState, action: NotificationDeletedAction): NotificationList {
    const notifications: NotificationList = [];

    for(let i = 0, l = state.notifications.length; i < l; i++) {
        if(state.notifications[i].id === action.id) {
            continue;
        }

        notifications.push(state.notifications[i]);
    }

    return notifications;
}

function insertNotificationIntoState(state: NotificationState, action: NotificationInsertAction): NotificationList {
    return [
        action.data,
        ...state.notifications,
    ];
}

function readAllNotificationsInState(state: NotificationState): NotificationList {
    const notifications: NotificationList = [];
    const current = moment().toISOString();

    for(let i = 0, l = state.notifications.length; i < l; i++) {
        notifications.push({
            ...state.notifications[i],
            readAt: current,
        });
    }

    return notifications;
}

function deleteAllNotificationsFromState(): NotificationList {
    return [];
}

function markNotificationAsRead(state: NotificationState, action: NotificationReadAction): NotificationList {
    const notifications: NotificationList = [];

    for(let i = 0, l = state.notifications.length; i < l; i++) {
        notifications.push({
            ...state.notifications[i],
            readAt: (
                action.id === state.notifications[i].id ?
                    moment().toISOString() :
                    state.notifications[i].readAt
            ),
        });
    }

    return notifications;
}

function NotificationsReducer(
    state: NotificationState | undefined,
    action: ShopfrontActions<NotificationActionTypes>
): NotificationState {
    if(typeof state === "undefined") {
        state = {
            loading      : false,
            notifications: [],
        };
    }

    switch(action.type) {
        case NOTIFICATIONS_FETCHING:
            return {
                ...state,
                loading: true,
            };
        case NOTIFICATIONS_FETCHED:
            // Override the notifications
            return {
                loading      : false,
                notifications: action.notifications,
            };
        case NOTIFICATION_DELETED:
            return {
                ...state,
                notifications: deleteNotificationFromState(state, action),
            };
        case NOTIFICATION_INSERT:
            return {
                ...state,
                notifications: insertNotificationIntoState(state, action),
            };
        case NOTIFICATION_ALL_READ:
            return {
                ...state,
                notifications: readAllNotificationsInState(state),
            };
        case NOTIFICATION_ALL_DELETE:
            return {
                ...state,
                notifications: deleteAllNotificationsFromState(),
            };
        case NOTIFICATION_READ:
            return {
                ...state,
                notifications: markNotificationAsRead(state, action),
            };
        default:
            return state;
    }
}

export default NotificationsReducer;
